"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreNumberBadge = _interopRequireDefault(require("@vfuk/core-number-badge"));

var Styled = _interopRequireWildcard(require("./styles/IconLateralMovement.style"));

var _ruleSet = require("../../ruleSet");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconLateralMovement = function IconLateralMovement(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? _ruleSet.nonThemeableRules.defaultSize : _ref$size,
      _ref$isResponsive = _ref.isResponsive,
      isResponsive = _ref$isResponsive === void 0 ? false : _ref$isResponsive,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      _ref$inverse = _ref.inverse,
      inverse = _ref$inverse === void 0 ? false : _ref$inverse,
      state = _ref.state,
      numberBadge = _ref.numberBadge;
  return /*#__PURE__*/_react["default"].createElement(Styled.IconWrapper, {
    size: size,
    isResponsive: isResponsive,
    appearance: appearance,
    inverse: inverse,
    state: state
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.5 17c-1.125.625-1.5 2.125-.309 3.25L15.5 21.5",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.5 15.5c.125 1.75 1.055 2.738 1.5 3 2.75 1.625 7.566 0 11 0 2.5 0 4 .875 5.5 3M11.29 2.824c-2.548-.367-3.087-.394-3.778-.355-.692.035-1.535-.125-2.532 1.539-1 1.664-1.605 2.61-1.84 3.21-.23.606-.413 2.891-.515 3.56-.102.671.375.921 1.219 1.042l6.011.875",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.344 11.895c-.14.988-.067.472-.14.96-.095.649-.224.75-1.028.625-.805-.125-.903-.25-.809-.894l.258-1.809m8.223-4.839c-.528-.079-2.02-.262-3.356-.485C6.16 5.227 6.27 4.18 6.566 3.34l.23-.793M6.54 7.883s.093-1.477-2.454-1.477",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.281 7.832c.25.25 1.563.691 3.258.05m4.751-5.058c2.542.371 3.065.5 3.718.727.652.226 1.508.324 1.992 2.199.484 1.875.8 2.957.852 3.602.05.644-.418 2.886-.516 3.558-.094.672-.625.777-1.465.652l-6.012-.874",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.375 13.488c-.14.992-.066.473-.14.961-.094.649 0 .778.812.895.808.117.933.02 1.027-.625l.262-1.809m-1.672-9.043c-.004.266.004.531.027.793.047.89-.14 1.922-1.488 1.762-1.344-.16-2.828-.406-3.355-.484m6.961 3.996c-.309.164-1.696.218-3.141-.875m.004-.016s.34-1.441 2.773-.711",
    vectorEffect: "non-scaling-stroke"
  }))), numberBadge ? /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
    number: numberBadge,
    appearance: inverse ? appearance : 'primary'
  })) : null);
};

IconLateralMovement.displayName = "IconLateralMovement";
var _default = IconLateralMovement;
exports["default"] = _default;
//# sourceMappingURL=IconLateralMovement.js.map